module.exports = __webpack_public_path__ + "static/media/05-print-ad.3fb64d6b.png";